import styled from "@emotion/styled";
import React from "react";
import { AddressComponents } from "../../../messages/Visit";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { CHEVRON_RIGHT_ICON, MARKER_ICON } from "../../../utils/svgs_new";
import { formatTaskAddress } from "../../../utils/taskUtils";
import { AppButton } from "../../Generic/AppButton";
import { AppIcon } from "../../Generic/AppIcon";
import { AppListItem } from "../../Generic/AppList";
import Flex from "../../Generic/Flex";

interface Props {
  addressString: string | null;
  addressComponents: AddressComponents | null;
  addressInstructions: string | null;
  onClickLocation: () => void;
}

const AvailableTaskAddress = (props: Props) => {
  const address = formatTaskAddress({
    addressString: props.addressString,
    addressComponents: props.addressComponents,
  });

  if (address === null) {
    return null;
  }

  const showAddressInstructions =
    props.addressInstructions !== null && props.addressInstructions.length > 1;

  return (
    <AppListItem
      leading={<AppIcon size={16} icon={MARKER_ICON} fill="primary" />}
      title={
        <Flex direction="column" yGap={8}>
          <span>{address}</span>
          {showAddressInstructions && <Directions>{props.addressInstructions}</Directions>}
        </Flex>
      }
      trailing={
        <Flex justifyContent="flex-end">
          <AppButton variant="outline" size="small">
            <span>{translate(STRINGS.MAP)}</span>
            <AppIcon size={16} icon={CHEVRON_RIGHT_ICON} />
          </AppButton>
        </Flex>
      }
      onClick={props.onClickLocation}
    />
  );
};

const Directions = styled.span`
  color: var(--gray-500);
`;

export default AvailableTaskAddress;
